export const slashBeforeUrlAdder = (url: string): string => {
  if (url && url[0] !== "/") {
    url = "/" + url;
  }
  return url;
};
